<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="150"
          height="150"
          class="iconMargin"
          src="../assets/pnf.png"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Metoda PNF - metoda reedukacji nerwowo-mięśniowej",
      wskazania: [
        "choroby powodujące zaburzenia w utrzymywaniu równowagi,",
        "u pacjentów, u których występują zaburzenia funkcji mięśni w postaci deficytu masy oraz siły mięśniowej,",
        "uszkodzenia tkanek miękkich aparatu ruchu: mięśni, ścięgien, więzadeł, torebek stawowych,",
        "zaburzenia prawidłowej postawy - reedukacja posturalna,",
        "bóle kręgosłupa segmentu szyjnego, piersiowego oraz lędźwiowo - krzyżowego.",
      ],
      opis1:
        "Uznana na całym świecie metoda, której filozofia polega na pozytywnym wykorzystaniu zasobów życiowych pacjenta w proces leczenia. W metodzie PNF pracuje się w oparciu o wzorce ruchowe oraz prawa neurofizjologii. Człowiek, który utracił zdolność wykonywania czynności w wyniku wylewu lub urazu, aby odzyskać funkcję uszkodzonej części ciała powinien zostać poddany reedukacji motorycznej. Reedukacja motoryczna (nauka ruchu) polega na stymulowaniu układu nerwowego w taki sposób, aby organizm odbudował utracone funkcje. Metoda ta umożliwia pełne wykorzystanie rezerw czynnościowych w organizmie, motywuje do dalszego działania, a co najważniejsze zapewnia bezbolesną pracę, bez „traumatyzujących” psychicznie i fizycznie doświadczeń.",
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>